import type { Dictionnaire } from '../type';

export const legal: Dictionnaire['legal'] = {
  documents: {
    cgu: 'Condiciones de uso',
    confidentialite: 'Política de privacidad',
    mentions: 'Aviso legal',
    version: (v: string) => `Versión ${v}`,
  },
  consentement: {
    titrePlusieurs: 'NUESTROS DOCUMENTOS HAN CAMBIADO',
    titreUn: 'UN DOCUMENTO HA CAMBIADO',
    textePlusieurs: 'Para seguir usando Sirocco, lee los dos documentos de abajo y acéptalos.',
    texteUn: 'Para seguir usando Sirocco, lee el documento de abajo y acéptalo.',
    accepter: 'Aceptar y continuar',
    deconnecter: 'Cerrar sesión',
  },
  ecran: {
    resumeCgu: 'Lo que aceptas al usar Sirocco.',
    resumeConfidentialite: 'Qué datos se recogen, por qué y durante cuánto tiempo.',
    resumeMentions: 'Quién publica la aplicación, quién la aloja y cómo contactarnos.',
    titre: 'Condiciones y privacidad',
    accepte: (cgu: string, confidentialite: string, quand: number | null) =>
      `Aceptaste la versión ${cgu} de las condiciones de uso y la versión ${confidentialite} de la política de privacidad${quand ? ` el ${new Date(quand).toLocaleDateString('es-ES')}` : ''}.`,
  },
  lien: {
    impossible: 'No se ha podido abrir la página. Esta es la dirección:',
  },
  miseAJour: {
    texte: 'Esta versión trae cambios que la aplicación no puede instalar por sí sola.',
    plusTard: 'Más tarde',
    mettreAJour: 'Actualizar',
    disponible: (version: string) => `Sirocco ${version} está disponible`,
  },
};
